import {useEffect, useRef, useState} from 'react'

const useIntersectionObserver = () => {
    const ref = useRef<HTMLDivElement>(null)
    const [observer, setObserver] = useState(false)
    useEffect(() => {
        if (!ref.current) return

        const observer = new IntersectionObserver((entries, observer) =>
            entries.forEach(entry => (entry.isIntersecting ? setObserver(false) : setObserver(true))),
        )
        observer.observe(ref.current)

        return () => observer.disconnect()
    }, [ref])
    return {observer, ref}
}
export default useIntersectionObserver
